





































































import Vue from 'vue'
import { Component, Prop, Watch, Emit } from 'vue-property-decorator'

import { Agency } from '@/modules/Agency/interfaces/agency'
import { dateTimeToDisplay, dateToDisplay } from '@/utils/dateTime'
import AppDialog from '@/components/AppDialog.vue'
import FoldingCard from '@/components/FoldingCard.vue'
import { mixins } from 'vue-class-component'
import AgencyDialog from '@/modules/Agency/scripts/agency-dialog'
import AppTextField from '@/components/AppTextField.vue'
import { SnackType } from '@/interfaces/snack'
import { showErrors, showNotification } from '@/utils/snack'
import { editAgency } from '@/modules/Agency/gql/agency.gql'
import { formatPhoneNumber } from '@/utils/phoneNumberFormat'
import delNonNumCode from '@/utils/delNonNumCode'

@Component({
  components: {
    FoldingCard,
    AppDialog,
    AppTextField
  }
})
export default class AgencyDetailDetail extends mixins(AgencyDialog) {
  @Prop({ type: Object as () => Agency }) readonly agency!: Agency

  dateTimeToDisplay = dateTimeToDisplay
  dateToDisplay = dateToDisplay
  formatPhoneNumber = formatPhoneNumber

  editBlock = ''

  agencyInput: {
    [key: string]: string;
  } = {
    name: '',
    phone: '',
    fax: '',
    mailingStreet: '',
    mailingCity: '',
    mailingState: '',
    mailingZipCode: '',
    mailingCountry: ''
  }

  @Watch('agency', { deep: true })
  onAgencyUpdated (val: Agency) {
    this.agencyInput = {
      name: val.name || '',
      phone: val.phone || '',
      fax: val.fax || '',
      mailingStreet: val.mailingStreet || '',
      mailingCity: val.mailingCity || '',
      mailingState: val.mailingState || '',
      mailingZipCode: val.mailingZipCode || '',
      mailingCountry: val.mailingCountry || ''
    }
  }

  @Watch('editBlock')
  editBlockChanged (val: string) {
    this.onAgencyUpdated(this.agency)
  }

  @Emit('success')
  onSuccess () {
    // do nothing
  }

  mounted () {
    if (this.$route.params.edit === 'true') {
      this.editAgency('agencyInfo')
    }
    this.onAgencyUpdated(this.agency)
  }

  editAgency (type: string) {
    this.editBlock = type
  }

  async editAgencyPost () {
    const {
      name, phone, fax, mailingStreet, mailingCity,
      mailingState, mailingZipCode, mailingCountry
    } = this.agencyInput

    const { id } = this.agency

    const editAgencyValid = (this.$refs.agencyInfoForm as Vue & { validate: () => boolean }).validate()

    if (!editAgencyValid) {
      return
    }

    try {
      const res = await this.$apollo.mutate({
        mutation: editAgency,
        variables: {
          agencyId: Number(id),
          agencyInput: {
            name,
            phone: delNonNumCode(phone),
            fax: delNonNumCode(fax),
            mailingStreet,
            mailingCountry,
            mailingState,
            mailingCity,
            mailingZipCode
          }
        }
      })
      showNotification({
        msg: 'Update the agency successfully',
        type: SnackType.Success
      })
      this.clearAgencyInput()
      this.onSuccess()
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  clearAgencyInput () {
    this.agencyInput = {
      name: '',
      email: '',
      phone: '',
      contact: ''
    }
  }
}
